module.exports = __webpack_public_path__ + "static/image/font/pc/bmjua-2@3x.ver2_0_2.jpg?f0fd8347";